export const getLastName = (name) =>
  name && name.trim().split(' ').splice(1).join(' ');
